/**
 * JavaScript для мобильного меню
 * Открытие/закрытие бургер-меню, подменю по клику
 */
document.addEventListener( 'DOMContentLoaded', function () {
	const headers = document.querySelectorAll( '.wp-block-blocks-albertlikhanov-block-header' );

	headers.forEach( function ( header ) {
		const burgerButton = header.querySelector( '.burger-menu-button' );
		const overlay = header.querySelector( '.mobile-menu-overlay' );
		const panel = header.querySelector( '.mobile-menu-panel' );

		if ( ! burgerButton || ! overlay || ! panel ) {
			return;
		}

		// Открыть меню
		function openMenu() {
			burgerButton.classList.add( 'is-active' );
			overlay.classList.add( 'is-visible' );
			panel.classList.add( 'is-open' );
			document.body.style.overflow = 'hidden';
		}

		// Закрыть меню
		function closeMenu() {
			burgerButton.classList.remove( 'is-active' );
			overlay.classList.remove( 'is-visible' );
			panel.classList.remove( 'is-open' );
			document.body.style.overflow = '';
		}

		// Клик по бургеру
		burgerButton.addEventListener( 'click', function () {
			if ( panel.classList.contains( 'is-open' ) ) {
				closeMenu();
			} else {
				openMenu();
			}
		} );

		// Клик по оверлею
		overlay.addEventListener( 'click', closeMenu );

		// Открытие/закрытие подменю по клику на пункт со стрелкой
		const menuItems = panel.querySelectorAll( '.menu-item--has-sub > .menu-link' );
		menuItems.forEach( function ( link ) {
			link.addEventListener( 'click', function ( e ) {
				const parentItem = this.closest( '.menu-item' );
				if ( ! parentItem ) return;

				// Если пункт не кликабельный (нет href) — просто открываем подменю
				if ( this.getAttribute( 'href' ) === '#' ) {
					e.preventDefault();
				}

				// Переключаем класс is-open
				parentItem.classList.toggle( 'is-open' );
			} );
		} );
	} );
} );
